import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ScaleLoader } from "react-spinners";
import Header from "./Header";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import Select from "react-select";
import { UserContext } from "../contexts/UserContext";
import ApiService from "../services/authservices";

function TeamHistory() {
  const [referralHistory, setReferralHistory] = useState([]);
  const [currentPageRef, setCurrentPageRef] = useState(1);
  const [totalPagesRef, setTotalPagesRef] = useState(0);
  const [limitRef, setLimitRef] = useState(20);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("");
  const [fuelBalanceFilter, setFuelBalanceFilter] = useState("");
  const { theme } = useContext(UserContext);

  const options = [
    { value: "", label: "All" },
    { value: "Active", label: "Active" },
    { value: "DeActive", label: "DeActive" },
  ];

  const [filters, setfilters] = useState({});

  useEffect(() => {
    fetchReferralHistory(filters, currentPageRef, limitRef);
  }, [filters, currentPageRef, limitRef]);

  const handlePageChangeRef = (event, value) => {
    setCurrentPageRef(value);
  };

  const fetchReferralHistory = async (filters, page, limit) => {
    try {
      setLoading(true);
      const data = await ApiService.getTeamHistory(filters, page, limit);
      if (data && data.status && Array.isArray(data.referralHistory)) {
        setReferralHistory(data.referralHistory);
        setTotalPagesRef(Math.ceil(data.pagination.totalPages));
        setLoading(false);
      } else {
        setReferralHistory([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching referral history:", error);
      setReferralHistory([]);
      setLoading(false);
    }
  };

  const handleFilterChange = () => {
    fetchReferralHistory(
      {
        botStatus: statusFilter || undefined,
        minFuelBalance: fuelBalanceFilter || undefined,
      },
      currentPageRef,
      limitRef
    );
  };

  const customStyles = {
    control: (styles) => ({
      ...styles,
      // backgroundColor: "#f9f9f9",
      // border: "1px solid #ccc",
      // padding: "4px",
      backgroundColor: theme === "dark" ? "transparent" : "#f9f9f9",
      //   border: `1px solid ${theme === "dark" ? "#2b3139" : "#ccc"}`,
      padding: "4px",
      color: theme === "dark" ? "#fff" : "#000",
      //   border: "none",
      boxShadow: "none", // Removes the box-shadow
      outline: "none", // Removes any outline
    }),
    option: (styles, { isFocused }) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",
      backgroundColor: isFocused
        ? theme === "dark"
          ? "#444"
          : "#e0e0e0"
        : theme === "dark"
        ? "#181a20"
        : "#fff",
      cursor: "pointer",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",
    }),
  };

  return (
    <div className="recent_depo_main">
      <div className="row">
        <div className="manage_btn_row">
          <span className="home_botstatus_span"> Team History</span>
          <Link to="/team">
            <div className="d-flex align-items-center gap-2 cursor-pointer">
              <span className="home_starty_view">Back to Your Team</span>
              <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
            </div>
          </Link>
        </div>
        <div className="col-lg-12 p-0">
          <div className="refer_third_main pb-0">
            <div className="refer_third_main-bot">
              <label>Bot Status:</label>
              {/* <select value={statusFilter}  className="black-dropdown" onChange={(e) => setStatusFilter(e.target.value)}>
                          <option value="">All</option>
                          <option value="Active">Active</option>
                          <option value="DeActive">DeActive</option>
                        </select> */}

              <div className="dropdown-container-newteamhis">
                <Select
                  value={options.find(
                    (option) => option.value === statusFilter
                  )}
                  onChange={(selectedOption) =>
                    setStatusFilter(selectedOption.value)
                  }
                  options={options}
                  className="teamhis-dropdown-menu"
                  styles={customStyles}
                />
                {/* <select
                  value={statusFilter}
                  className="black-dropdown"
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="">All</option>
                  <option value="Active">Active</option>
                  <option value="DeActive">DeActive</option>
                </select> */}
              </div>

              <label className="refer_third_main-fuel">Fuel Balance:</label>
              <input
                type="number"
                className="fuel_balance"
                value={fuelBalanceFilter}
                onChange={(e) => {
                  if (e.target.value.length <= 8) {
                    setFuelBalanceFilter(e.target.value);
                  }
                }}
                placeholder="Min Fuel Balance"
              />

              <button className="filter-apply" onClick={handleFilterChange}>
                Apply Filters
              </button>
            </div>
            <div className="table-responsive table-borderless home_recent_table teamistoryhome_recent_table">
              {loading ? (
                <div className="loader_main loader_mainChange">
                  <ScaleLoader color="#20A1FD" height={10} width={3} />
                  <p>Loading...</p>
                </div>
              ) : (
                <>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>SI.no</th>
                        <th>Name</th>
                        <th>UserID</th>
                        <th>Tier</th>
                        <th>Fuel Balance</th>
                        <th>Bot Status</th>
                        <th>Cumulative Profit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {referralHistory.length > 0 ? (
                        referralHistory.map((referral, index) => (
                          <tr key={referral.uuid}>
                            {/* <td className="text_left"> */}
                            <td>
                              <span>{index + 1}</span>
                            </td>
                            <td>
                              <span>{referral.displayname}</span>
                            </td>
                            <td>
                              <span>{referral.referralCode}</span>
                            </td>
                            <td>
                              <span>{referral.tier.toUpperCase()}</span>
                            </td>
                            <td>
                              <span>{referral.fuel_balance}</span>
                            </td>
                            <td>
                              <span>{referral.botStatus}</span>
                            </td>
                            <td>
                              <span>{referral.overallProfit}</span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            <span className="depo_no_record">
                              No team history available.
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {totalPagesRef > 1 && (
                    <div className="pagination history_pagination_all ">
                      <Stack spacing={2}>
                        <Pagination
                          count={totalPagesRef}
                          page={currentPageRef}
                          onChange={handlePageChangeRef}
                          size="small"
                          sx={{
                            "& .MuiPaginationItem-root": {
                              color: "#fff",
                            },
                            "& .Mui-selected": {
                              backgroundColor: "#ffc630 !important",
                              color: "#000",
                              "&:hover": {
                                backgroundColor: "#ffc630",
                                color: "#000",
                              },
                            },
                            "& .MuiPaginationItem-ellipsis": {
                              color: "#fff",
                            },
                            "& .MuiPaginationItem-icon": {
                              color: "#fff",
                            },
                          }}
                        />
                      </Stack>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamHistory;
